jQuery(function($){

    let zoomingVideo = $('.zooming-video');

    if (zoomingVideo.length == 0){
        return;
    }

    var $video = zoomingVideo.find('video');
    var $videoWrap = zoomingVideo.find('.video-wrap');

    $videoWrap.on('click', function(){
        let video = $video[0];
        video.muted = !video.muted;

        var playButton = $(this).find('.zooming-video__play');
        var playButtonImg = playButton.find('.zooming-video__play img');
        var playButtonText = playButton.find('.zooming-video__text'); 
        var playIcon = playButtonImg.data('play-src');
        var pauseIcon = playButtonImg.data('pause-src');

        // Toggle a class based on whether the video is muted
        if (video.muted) {
            playButtonImg.attr('src', playIcon);
            playButtonText.text('Schakel audio in');
            playButton.addClass('muted');
            $video.addClass('muted');
        } else {
            playButtonImg.attr('src', pauseIcon);
            playButtonText.text('Schakel audio uit');
            playButton.removeClass('muted');
            $video.removeClass('muted');
        }
    });
    
    function setClipPath() {
        var rect = $videoWrap[0].getBoundingClientRect();
        var windowHeight = $(window).height();
        
        // Calculate the percentage of the video in the viewport
        // visibleRatio will be 1 when the top of the element reaches halfway up the viewport
        var halfWayPoint = windowHeight / 2;
        var visibleRatio = Math.max(0, Math.min(1, (windowHeight - rect.top) / (halfWayPoint + rect.height / 2)));
        
        // Interpolate between the initial and final values
        var topStart = 15, topEnd = 0;
        var leftStart = 20, leftEnd = 0;
        var rightStart = 80, rightEnd = 100;

        var topPercent = topStart + (topEnd - topStart) * visibleRatio;
        var leftPercent = leftStart + (leftEnd - leftStart) * visibleRatio;
        var rightPercent = rightStart + (rightEnd - rightStart) * visibleRatio;
        
        // Apply the new clip-path
        $video.css('clip-path', `polygon(${leftPercent}% ${topPercent}%, ${rightPercent}% ${topPercent}%, ${rightPercent}% 100%, ${leftPercent}% 100%)`);
    }
    
    // Initial setting
    setClipPath();

    // For speed reasons I only want the scroll event to fire when the section is actually in view
    let intersectTrigger = document.querySelector('.zooming-video');

    function handleIntersect(entries, observer) {
        entries.forEach(entry => {       
            if (entry.isIntersecting) {
               // Update clip-path on scroll
                $(window).on('scroll.zooming-video', setClipPath);          
            }
            else {
                $(window).off('scroll.zooming-video');
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersect, {
        root: null, 
        threshold: 0 
    });

    observer.observe(intersectTrigger);
});